import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonSpacing: {
      marginRight: theme.spacing(2),
      width: 'max-content'
    }
  })
);

interface AddCreateButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const AddCreateButton: React.FC<AddCreateButtonProps> = ({ onClick, children = null }) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.buttonSpacing}
      onClick={onClick}
      aria-label="Add Button"
      variant="contained"
      color="primary"
      size="large"
      disableElevation
      startIcon={<AddCircleIcon />}
    >
      {children || <span />}
    </Button>
  );
};
export default AddCreateButton;
